import { render, staticRenderFns } from "./ReservationInfo.vue?vue&type=template&id=5ee87978&scoped=true"
import script from "./ReservationInfo.vue?vue&type=script&lang=js"
export * from "./ReservationInfo.vue?vue&type=script&lang=js"
import style0 from "./ReservationInfo.vue?vue&type=style&index=0&id=5ee87978&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ee87978",
  null
  
)

export default component.exports